import type { DropInPaymentOption } from "@bw/shared/types";
import { formatMoney } from "@bw/shared/utils";
import type { PaymentSelection } from "./components/PaymentMethodSelect";

export type DropInPricePresentation = {
  total: string;
  original: string | null;
  savingsLabel: string | null;
  campaignName: string | null;
};

export function dropInPricePresentation(
  options: DropInPaymentOption | undefined,
  selection: PaymentSelection | null,
  recovering: boolean,
): DropInPricePresentation {
  if (recovering)
    return {
      total: "Pending reconciliation",
      original: null,
      savingsLabel: null,
      campaignName: null,
    };
  if (selection?.method === "membership")
    return {
      total: "Included with membership",
      original: null,
      savingsLabel: null,
      campaignName: null,
    };
  if (selection?.method === "package")
    return {
      total: "1 visit",
      original: null,
      savingsLabel: null,
      campaignName: null,
    };
  if (options?.single_price == null)
    return {
      total: "Not available",
      original: null,
      savingsLabel: null,
      campaignName: null,
    };
  const total = formatMoney(
    options.single_total ?? options.single_price,
    options.currency,
  );
  if (!options.campaign)
    return { total, original: null, savingsLabel: null, campaignName: null };
  return {
    total,
    original: formatMoney(options.single_price, options.currency),
    savingsLabel: formatMoney(options.campaign.discount, options.currency),
    campaignName: options.campaign.name,
  };
}
